<template>
  <nav class="navbar is-primary no-print" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <!-- Hamburger icon -->
      <a
        role="button"
        class="navbar-burger"
        :class="{ 'is-active': isMenuActive }"
        aria-label="menu"
        aria-expanded="false"
        @click="toggleMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <!-- Add your left-side navigation items here -->
      </div>

      <div class="navbar-end">
        <!-- Dropdown for Competition -->
        <!-- Dropdown for Registration -->
        

        <div class="navbar-item">
          <router-link
            @click.native="menuClicked"
            class="navbar-item custom-link"
            to="/event/eventForm"
            :exact="true"
            active-class="is-active"
          >
            <span v-if="switchLang == 1">ໜ້າຫຼັກ</span>
            <span v-else>Home</span>
          </router-link>
        </div>

        <!-- <div class="navbar-item">
          <router-link
            @click.native="menuClicked"
            class="navbar-item custom-link"
            to="/event/eventForm"
            :exact="true"
            active-class="is-active"
          >
            <span v-if="switchLang == 1">ຂ່າວສານ</span>
            <span v-else>News and Events</span>
          </router-link>
        </div> -->

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'news' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('news')">
            <span  v-if="switchLang == 1">ຂ່າວສານ</span>
            <span  v-else>News and Events</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'news'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/news/inexpo"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ເຊີນທ່ຽວຊົມງານ Agri-Expo 2024</span>
              <span  v-else>Welcome to Agri-Expo 2024</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/news/news02"
              :exact="true"
              active-class="is-active"
            >
              
              <span  v-if="switchLang == 1">ຖະແຫຼງຂ່າວງານ Laos Expo 2024</span>
              <span  v-else>News release of Laos Expo 2024</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ການແຂ່ງຂັນ</span>
              <span  v-else>Competition</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">New Open Fish Project</span>
              <span  v-else>New Open Fish Project</span>
            </router-link>

          </div>
          
          
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'expo' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('expo')">
            <span  v-if="switchLang == 1">ງານວາງສະແດງສິນຄ້າກະສິກຳປະຈຳປີ 2024</span>
            <span  v-else>Agri-Expo 2024</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'expo'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event2024/agentda"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ວາລະງານວາງສະແດງສິນຄ້າກະສິກຳ ປະຈຳປີ 2024</span>
              <span  v-else>Agenda of Lao Agri Expo2024</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Join events</span>
              <span  v-else>Join events</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Statistic of participant</span>
              <span  v-else>Statistic of participant</span>
            </router-link>
          </div>
          
          
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'mou' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('mou')">
            <span  v-if="switchLang == 1">ໂຄງການກະສິກຳ (MOU)</span>
            <span  v-else>Agriculture Projects</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'mou'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/mou/adra"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ADRA-SARLI Project</span>
              <span  v-else>ADRA-SARLI Project</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/mou/fvc"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ໂຄງການສ້າງຄວາມເຂັ້ມແຂງໃຫ້ແກ່ຕ່ອງໂສ່ມູນຄ່າອາຫານ (FVC)</span>
              <span  v-else>Strengthening Food value chain Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/mou/sweetpotato"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ໂຄງການມັນດ້ານຫວາຍິປຸ່ນ</span>
              <span  v-else>Sweet Potato Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/mou/chili"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ໂຄງການໝາກເຜັດ</span>
              <span  v-else>Chili Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Fish Project</span>
              <span  v-else>Fish Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Crow Project</span>
              <span  v-else>Crow Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Green Onnion Project</span>
              <span  v-else>Green Onnion Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Coconut Project</span>
              <span  v-else>Coconut Project</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/event/eventForm"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Duck Project</span>
              <span  v-else>Duck Project</span>
            </router-link>
          </div>
          
          
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'matching' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('matching')">
            <span  v-if="switchLang == 1">ຈັບຄູ່ທຸລະກິດ</span>
            <span  v-else>Business Matching</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'matching'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/business/businessmatching"  
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Statistic of matching</span>
              <span  v-else>Statistic of matching</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/business/businessmatchinginterested"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Find out business partner</span>
              <span  v-else>Find out business partner</span>
            </router-link>

           
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'member' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('member')">
            <span  v-if="switchLang == 1">ສະມາຊິກສະມາຄົມ</span>
            <span  v-else>LABA Member</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'member'">  
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/laba/member"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ຂໍ້ມູນສະມາຊິກ</span>
              <span  v-else>Member info</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/association/associationFormbySelf"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">Register member</span>
              <span  v-else>Register member</span>
            </router-link>

            

           
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'sponser' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('sponser')">
            <span  v-if="switchLang == 1">ຜູ້ສະໜັບສະໜູນ</span>
            <span  v-else>Sponsorships</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'sponser'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/sponsor/lababizsponsor"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ຜູ້ສະໜັບສະໜູນເວັບໄຊສະມາຄົມ</span>
              <span  v-else>Lababiz Dev Sponsor</span>
            </router-link>
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/sponser/adra"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">ຜູ້ສະໜັບສະໜູນ Agri-Expo 2024</span>
              <span  v-else> Agri-Expo 2024 Sponsor</span>
            </router-link>
          </div>
        </div>

        <div class="navbar-item has-dropdown" :class="{ 'is-active': activeDropdown === 'about' }">
          <a class="navbar-link" @click.prevent="toggleDropdown('about')">
            <span  v-if="switchLang == 1">ກ່ຽວກັບສະມາຄົມ</span>
            <span  v-else>About LABA</span>
          </a>
          <div class="navbar-dropdown" v-if="activeDropdown === 'about'">
            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/laba/about"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">About LABA</span>
              <span  v-else>About LABA</span>
            </router-link>

            <router-link
              @click.native="menuClicked"
              class="navbar-item"
              to="/laba/remark"
              :exact="true"
              active-class="is-active"
            >
              <span  v-if="switchLang == 1">LABA President Remark</span>
              <span  v-else>LABA President Remark</span>
            </router-link>
          </div>
        </div>

       

        <!-- Language Change -->
        <div class="navbar-item is-hoverable" style="margin-left: 10px;">
          <img class="image-area" :src="getFlag()" @click="changeLang" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false, // Toggles the main menu visibility (hamburger menu)
      activeDropdown: null, // Tracks the currently active dropdown menu
      switchLang: 1, // Language switch: 1 for Lao, 2 for English
      photopath: process.env.NODE_ENV === "production" 
                ? "https://lababiz.com/api/uploads/flag/"
                : "http://localhost/lababiz/api/uploads/flag/"
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive; // Toggle the hamburger menu
    },
    toggleDropdown(menu) {
      this.activeDropdown = this.activeDropdown === menu ? null : menu; // Toggle the dropdown
    },
    menuClicked() {
      this.activeDropdown = null; // Close the submenu when an item is clicked
    },
    changeLang() {
      this.switchLang = this.switchLang === 1 ? 2 : 1; // Toggle language
      this.$store.set("switchLang", this.switchLang); // Save the selected language to store
    },
    getFlag() {
      return this.photopath + (this.switchLang === 1 ? "en.png" : "la.png"); // Return the appropriate flag image
    }
  }
};
</script>

<style scoped>
.has-dropdown {
  margin-top: 6px;
  margin-left: 12px;
  margin-right: 12px;
}

.navbar-item {
  white-space: nowrap;
  transition: color 0.3s ease;
}

/* Default styles for large screens */
.navbar-item.custom-link {
  color: white; /* Default text color */
  background-color: #039be5;
}

/* Hover effect */
.navbar-item.custom-link:hover {
  /* background-color: #007bff; Background color when hovering */
  color: white; /* Color when hovering */
}

/* Active link state */
.navbar-item.custom-link.is-active {
  /* background-color: #007bff; Background color when the link is active */
  color: white; /* Color when the link is active */
}

.navbar-end {
  padding-right: 60px;
}

.navbar-burger span {
  background-color: white; /* Customize the hamburger menu color */
}

.navbar-link {
  cursor: pointer; /* Pointer cursor for clickable menu links */
}

.navbar-dropdown {
  animation: fadeIn 0.3s; /* Optional fade-in animation for submenu */
}

/* Media query for small screens (hamburger menu active state) */
@media screen and (max-width: 768px) {
  /* Change text color to blue when menu is active on small screens */
  .navbar-menu.is-active .navbar-item.custom-link {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* On hover, change text color to dark blue */
  .navbar-menu.is-active .navbar-item.custom-link:hover {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  .navbar-menu.is-active .navbar-item.custom-link.is-active {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* Ensure the menu background color is still white on small screens */
  .navbar-menu.is-active {
    background-color: white;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
